/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { type ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import type { User } from '@/configs/apis/user';
import { GroupPosition } from '@/configs/apis/groups/interface';
import List from '@/components/list';
import { useChatContext } from '@/contexts/chat/context';
import ChatSettingDrawer from '@/components/chat-setting-drawer';
import { GroupApplications } from '../group-applications';
// import SearchIcon from './images/search.svg?react';
import LinkIcon from './images/link.svg?react';
// import ScanIcon from './images/scan.svg?react';
import styles from './index.module.scss';
import { GroupSettingButtonCard } from './components/group-setting-button-card';
import { GroupSettingReport } from './components/group-setting-report';
import GroupDescription from './components/group-description';
import GroupSettingMembers from './components/group-setting-members';
import GroupHeader from './components/group-header';

interface GroupSettingProps {
  chat: Chat;
  user: User | null;
  normalMemberList: ChatGroupMember[];
  open: boolean;
  onCancel: () => void;
  handleSearch: () => void;
  handleShare: () => void;
  handAddMembers: () => void;
  handDeleteMembers: () => void;
  handSearchMembers: () => void;
}

const GroupSetting = ({
  chat,
  user,
  normalMemberList,
  open,
  onCancel,
  // handleSearch,
  // handleShare,
  handAddMembers,
  handDeleteMembers,
  handSearchMembers,
}: GroupSettingProps) => {
  const {
    chatGroup: { chatGroupState, insertSettings, updateGroups },
  } = useChatContext();

  const settings = useMemo(() => {
    return chatGroupState.state.settingsMap[chat.chat_id];
  }, [chat.chat_id, chatGroupState.state.settingsMap]);

  const groupOwner = useMemo(() => {
    return normalMemberList?.find((item) => item.role === GroupPosition.Owner);
  }, [normalMemberList]);

  const groupManager = useMemo(() => {
    return normalMemberList?.find((item) => item.role === GroupPosition.Manager);
  }, [normalMemberList]);

  const isGroupOwner = useMemo(() => {
    return groupOwner?.user_id === user?.userId;
  }, [groupOwner, user?.userId]);

  const isGroupManager = useMemo(() => {
    return groupManager?.user_id === user?.userId;
  }, [groupManager, user?.userId]);

  return (
    <ChatSettingDrawer
      className={styles.groupSettingModal}
      open={open}
      // destroyOnHidden={true} 5.25 support
      text="Group Setting"
      onCancel={onCancel}
      onClose={onCancel}
    >
      <div className={styles.content}>
        <GroupHeader
          chat={chat}
          isGroupOwner={isGroupOwner}
          isGroupManager={isGroupManager}
          normalMemberList={normalMemberList}
          insertSettings={insertSettings}
          updateGroups={updateGroups}
        />
        {/* <List
          title="Share link"
          desc="https://www.box.com/chat/xxx"
          icon={<LinkIcon />}
          operationIcon={
            <ScanIcon
              onClick={(e) => {
                e.stopPropagation();
                console.log('scan');
              }}
            />
          }
          onClick={() => {
            console.log('first');
          }}
        /> */}
        {/* <GroupDescription
          chat={chat}
          description={settings.description}
          isGroupOwner={isGroupOwner}
          isGroupManager={isGroupManager}
          insertSettings={insertSettings}
        /> */}

        <GroupSettingMembers
          chat={chat}
          user={user}
          normalMemberList={normalMemberList}
          showManager={isGroupOwner || isGroupManager}
          handSearchMembers={handSearchMembers}
          handAddMembers={handAddMembers}
          handDeleteMembers={handDeleteMembers}
          closeSettings={onCancel}
        />

        {/* <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.title}>Group Applications</div>
          </div>
          <div className={styles.cardBody}>
            <GroupApplications />
          </div>
        </div> */}
        {/* <List
          title="Edit My Name in Group"
          content={<span style={{ color: '#703EFF' }}>Camille</span>}
          icon={<LinkIcon />}
        />
        <List
          title="Mute notifications"
          content={<Switch />}
          icon={<LinkIcon />}
          operationIcon={null}
        />
        <List
          title="Mute @All mentions"
          content={<Switch value={true} />}
          icon={<LinkIcon />}
          operationIcon={null}
        />
        <List
          title="Pin to top"
          content={<Switch value={true} />}
          icon={<LinkIcon />}
          operationIcon={null}
        />
        <List title="Tags" icon={<LinkIcon />} />
        <List
          title="Flag"
          content={<Switch value={true} />}
          icon={<LinkIcon />}
          operationIcon={null}
        />
        <List
          title="Auto-Delete Messages"
          content={<span style={{ color: '#703EFF' }}>1 week</span>}
          icon={<LinkIcon />}
        />
        <List
          title="Collapse Group in Settings"
          content={<Switch value={false} />}
          icon={<LinkIcon />}
          operationIcon={null}
        /> */}
        <GroupSettingButtonCard
          chat={chat}
          user={user}
          normalMemberList={normalMemberList}
          closeSettings={onCancel}
          isGroupOwner={isGroupOwner}
          isGroupManager={isGroupManager}
        />
        {/* <GroupSettingReport /> */}
      </div>
    </ChatSettingDrawer>
  );
};
export default GroupSetting;
